/* eslint-disable prettier/prettier, linebreak-style, indent */
/* global jQuery */
class FeaturedPostsSlider {
  constructor() {
    this.selectors = {
      slider: '.js-featured-posts-slider',
    };

    this.DOM = {
      sliders: document.querySelectorAll(this.selectors.slider),
    };

    this.classes = {};

    window.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    if (this.DOM.sliders.length) {
      this.DOM.sliders.forEach((slider) => {
        const { infinite, mobileVariableWidth } = slider.dataset;
        jQuery(slider).slick({
          slidesToShow: 1,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25 0C11.1921 0 0 11.1921 0 25C0 38.8079 11.1921 50 25 50C38.8079 50 50 38.8079 50 25C50 11.1921 38.8079 0 25 0ZM31.6128 34.1646L27.2866 38.4909L13.7957 25L27.2866 11.5091L31.6128 15.8354L22.4482 25L31.6128 34.1646Z" fill="white"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next slick-arrow"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25 50C38.8079 50 50 38.8079 50 25C50 11.1921 38.8079 -9.78442e-07 25 -2.18557e-06C11.1921 -3.3927e-06 3.3927e-06 11.1921 2.18557e-06 25C9.78442e-07 38.8079 11.1921 50 25 50ZM18.3872 15.8354L22.7134 11.5091L36.2043 25L22.7134 38.4909L18.3872 34.1646L27.5518 25L18.3872 15.8354Z" fill="white"/></svg></button>',
          dots: true,
          autoplay: false,
          infinite: infinite !== '0',
          responsive: [
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                variableWidth: mobileVariableWidth === '1',
              },
            },
          ],
        });
      });
    }
  }
}

export default new FeaturedPostsSlider();
